import React from 'react'
import { Container as ContainerBase, Grid as GridBase, styled } from '@mui/material'

export const Root = styled(ContainerBase)`
  &.MuiContainer-root {
    width: 100%;
  }
`
export const GridContainer = styled(({ margin, padding, ...props }) => <GridBase container {...props} />)`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
  &.containerTable {
    width: 100%;
    overflow-x: auto;
    th {
      white-space: nowrap;
      font-size: 14px;
      color: #2e384d;
      font-weight: 700;
      &:first-child {
        width: 92px;
      }
    }
    td {
      white-space: nowrap;
      font-size: 14px;
      color: #2e384d;
    }
    .fKozgr.MuiPaper-root {
      justify-content: center;
    }
    .orderableCell {
      :hover {
        cursor: pointer;
      }
      :after {
        content: '';
        display: inline-block;
        border-bottom: 1px solid rgb(159 159 159);
        border-right: 1px solid rgb(159 159 159);
        height: 7px;
        width: 7px;
        -webkit-transform: rotate(47deg);
        -ms-transform: rotate(47deg);
        transform: rotate(47deg);
        margin-left: 10px;
        margin-bottom: 2px;
        transition: transform 1s, margin-bottom 1s;
      }
      &.active {
        :after {
          border-bottom: 1px solid rgb(0 0 0);
          border-right: 1px solid rgb(0 0 0);
        }
        &.orderDesc {
          :after {
            -webkit-transform: rotate(225deg);
            -ms-transform: rotate(225deg);
            transform: rotate(225deg);
            margin-bottom: -3px;
          }
        }
      }
    }
  }
  .containerButtons {
    margin-top: 15px;
  }
  &.filterProductsContainer {
    display: flex;
    justify-content: space-between;
  }
  &.containerTableModal {
    overflow-y: scroll;
    max-height: 400px;
    margin: 10px 0;
  }
  &.containerFilterInputs {
    .MuiGrid-item {
      width: 20%;
    }
  }
  &.containerSubmitButtonFilter {
    justify-content: end;
  }
`

export const GridItem = styled(({ margin, padding, visibility, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
    visibility: ${props => props.visibility};
  }
`
export const Title = styled('h2')`
  font-size: 27px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 31px;
  margin: 20px 0;
`
export const Subtitle = styled('h4')`
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 31px;
  margin: 20px 0;
`

export const Content = styled('form')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px;
`
export const ContainerSwitch = styled('div')`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
  height: 100%;
`
